import React from 'react';
import { Link } from 'react-router-dom';

const Logo = ({ className = "" }) => {
  return (
    <Link to="/" className={`flex items-center space-x-3 ${className}`} data-testid="logo-link">
      <div className="relative">
        {/* Logo Icon */}
        <div className="relative h-10 w-10 rounded-xl bg-gradient-to-br from-blue-500 to-mint-400 p-0.5">
          <div className="flex h-full w-full items-center justify-center rounded-[10px] bg-white">
            <svg
              className="h-6 w-6 text-blue-600"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2.5}
                d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6"
              />
            </svg>
          </div>
        </div>
      </div>
      {/* Logo Text */}
      <div className="flex flex-col leading-none">
        <span className="text-xl font-bold text-slate-900">
          financially<span className="text-mint-500">free</span>
        </span>
      </div>
    </Link>
  );
};

export default Logo;